import { addMonths, startOfMonth } from 'date-fns';

export function calculateEarliestStartOfInsurance(date) {
  const today = date ?? new Date();
  return today.getDate() === 1 ? today : startOfMonth(addMonths(today, 1));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);
}

export function findBestMatchingProduct(products, versicherungssumme) {
  const matchingProducts = products.filter(product => product.maximumCoveredValue >= versicherungssumme);

  if (matchingProducts.length === 0) {
    return null;
  }
  const bestMatchingProduct = matchingProducts.reduce((best, current) => {
    if (!best || current.maximumCoveredValue < best.maximumCoveredValue) {
      return current;
    }
    return best;
  }, null);

  return JSON.parse(JSON.stringify(bestMatchingProduct)); // deep clone
}

export const isoNamingForSexToAnredeMap = {
  FEMALE: 'frau',
  MALE: 'herr',
  NOT_APPLICABLE: 'divers',
  NOT_KNOWN: '',
};

export const anredeToIsoNamingForSexMap = Object.fromEntries(
  Object.entries(isoNamingForSexToAnredeMap).map(([iso, anrede]) => [anrede, iso]),
);
